<script type="text/ecmascript-6">
    import DesignerQuestionHardwareKeyQty from "../DesignerQuestionHardwareKeyQty.vue";

    export default {
        mixins: [
            DesignerQuestionHardwareKeyQty,
        ],
        computed: {
            key_amount_text() {
              const selectedOption = this.filtered_option_list.find(option => option.value === this.localTarget);

              if(selectedOption){
                  const amount = parseInt(selectedOption.label) + 3;
                  if (selectedOption) {
                      return amount + ' keys in total';
                  }
              }

              return '';
            },
        },
    }
</script>
